import { useId } from 'react';

interface MaudMarkProps {
  size?: number;
  className?: string;
}

const MaudMark = ({ size = 28, className = '' }: MaudMarkProps) => {
  const gradientId = `maud-grad-${useId()}`;

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        flexShrink: 0,
      }}
      aria-hidden="true"
    >
      <svg
        viewBox="0 0 40 40"
        width={size}
        height={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            id={gradientId}
            x1="30"
            y1="4"
            x2="8"
            y2="38"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#E5F0AE" />
            <stop offset="35%" stopColor="#BFEAD9" />
            <stop offset="72%" stopColor="#92B0F6" />
            <stop offset="100%" stopColor="#6C8FF2" />
          </linearGradient>
        </defs>
        <circle cx="20" cy="20" r="20" fill={`url(#${gradientId})`} />
        <path
          d="M22.4 11.2 L14.6 21.8 a0.5 0.5 0 0 0 0.4 0.8 H18.6 L17.4 28.5 a0.45 0.45 0 0 0 0.82 0.34 L25.6 18.5 a0.5 0.5 0 0 0 -0.4 -0.8 H21.6 L22.9 11.7 a0.45 0.45 0 0 0 -0.86 -0.34 Z"
          fill="#FFFFFF"
        />
      </svg>
    </span>
  );
};

export default MaudMark;
